(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("YPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["YPlayer"] = factory();
	else
		root["YPlayer"] = factory();
})(window, function() {
return 